/* istanbul ignore file */
export default {
  showPopover: 'Show Popover'
};
